import { render, staticRenderFns } from "./calcdetail.vue?vue&type=template&id=1c84a134&scoped=true"
import script from "./calcdetail.vue?vue&type=script&lang=js"
export * from "./calcdetail.vue?vue&type=script&lang=js"
import style0 from "./calcdetail.vue?vue&type=style&index=0&id=1c84a134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84a134",
  null
  
)

export default component.exports